/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { amplify } from './config/amplify.dev';
const { version } = require('../../package.json');

export const environment = {
  amplify,
  production: false,
  version,
  SVC_API: 'https://api.dev.app.1bill.com/v2a/',
  SVC_API_B: 'https://api.dev.app.1bill.com/v2b/',
  ADMIN_SVC_API: 'https://api.dev.app.1bill.com/admin-v2',
  ADMIN_SVC_API_B: 'https://api.dev.app.1bill.com/admin-v2-b',
  ADMIN_SVC_API_KEY: '',
  ZOHO_DEAL_URL: 'https://crmsandbox.zoho.com.au/crm/org7000130519/tab/Potentials',
};
